// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import styled, { css } from "styled-components";

const ButtonSubmit = styled(Button)`
    ${props =>
        props.disabled &&
        css`
            background-color: ${getColor("primary.main")}; !important;
        `}
    font-weight: 700;
`;
interface Props {
    handleSubmit: () => Promise<void>;
    isLoading: boolean;
    disabled?: boolean;
}

const StyledSpan = styled.span`
    color: ${getColor("primary.main")};
`;
const SearchButtonSubmitFilter: React.FC<Props> = ({ handleSubmit, isLoading, disabled = false }) => {
    return (
        <Button sizeVariant="medium" onClick={handleSubmit} data-test-selector="savedOrderList_applyFiltersButton">
            {translate("Apply Filters")}
        </Button>
    );
};

export default SearchButtonSubmitFilter;
